export default __webpack_public_path__ + "static/media/lightsout.f15528ea.PNG";